export default __webpack_public_path__ + "static/media/img59.af2dc0e1.jpg";